// extracted by mini-css-extract-plugin
module.exports = {"root":"rdg_d6bc2d77","item":"rdg_8ef10eba"};